import { render, staticRenderFns } from "./SmallFlightItinerary.vue?vue&type=template&id=1fc6c8ab&scoped=true&"
import script from "./SmallFlightItinerary.vue?vue&type=script&lang=js&"
export * from "./SmallFlightItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6c8ab",
  null
  
)

export default component.exports